import { grid, maxWidthContainer, minBreakpoints, primarySemiBoldFont, responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
export var container = /*#__PURE__*/css(["", " ", " grid-row-gap:0;"], grid, maxWidthContainer);
export var topOffsetImageMarginContainer = /*#__PURE__*/css(["", ";"], mediaQuery({
  min: minBreakpoints.L
}, css(["padding-bottom:", ";"], pxToRem(spacing.xl))));
export var content = /*#__PURE__*/css(["text-align:center;grid-column:span 12;margin-top:-", ";margin-bottom:", ";", " ", ";"], pxToRem(spacing.md), pxToRem(spacing.xl), mediaQuery({
  min: minBreakpoints.M
}, css(["margin-top:0;margin-bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:center;order:1;grid-column:span 6;"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["grid-column:2 / span 4;"])));
export var lightTextContent = /*#__PURE__*/css(["*{color:var(--neutral-white-base);}"]);
export var darkTextContent = /*#__PURE__*/css(["*{color:var(--neutral-black-base);}"]);
export var imageWrapper = /*#__PURE__*/css(["grid-column:span 12;", ";", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["order:2;grid-column:span 6;"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["grid-column:7 / span 5;"])));
var sharedStyles = /*#__PURE__*/css(["margin:", " 0 0;*{margin:0;font-size:inherit;line-height:inherit;}"], pxToRem(spacing.md));
export var heading = /*#__PURE__*/css(["margin:", " 0 0;", ";", ""], pxToRem(spacing.xl), primarySemiBoldFont, mediaQuery({
  min: minBreakpoints.M
}, css(["margin:0;"])));
export var headingWithButton = /*#__PURE__*/css(["", ";"], responsiveFontSize({
  XXS: text.HEADING.MD,
  L: text.HEADING.XL
}));
export var headingWithoutButton = /*#__PURE__*/css(["", ";"], responsiveFontSize({
  XXS: text.HEADING.MD,
  L: text.HEADING.LG,
  XL: text.HEADING.XL
}));
export var innerHeading = /*#__PURE__*/css(["display:block;> span{display:inline-block;}"]);
export var innerHeadingUnderline = /*#__PURE__*/css(["box-shadow:inset 0px -12px 0px var(--underlineColor);"]);
export var subHeading = /*#__PURE__*/css(["", ";"], sharedStyles);
export var subHeadingWithButton = /*#__PURE__*/css(["", ";"], responsiveFontSize({
  XXS: text.BODY.MD,
  L: text.HEADING.SM
}));
export var subHeadingWithoutButton = /*#__PURE__*/css(["", ";"], responsiveFontSize({
  XXS: text.BODY.MD,
  L: text.HEADING.XS,
  XL: text.HEADING.SM
}));
export var copy = /*#__PURE__*/css(["font-size:", "px;line-height:", "px;", ";"], text.BODY.XS.fontSize, text.BODY.XS.lineHeight, sharedStyles);
export var buttonContainer = /*#__PURE__*/css(["margin:", " 0 0;", " ", ""], pxToRem(spacing.xl), mediaQuery({
  min: minBreakpoints.M
}, css(["margin-bottom:0;"])), mediaQuery({
  min: minBreakpoints.L
}, css(["margin:", " 0 0;"], pxToRem(spacing.xxl))));